import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layer,
  Gallery,
  Edit2,
  Link21,
  FingerScan,
  Box1,
  RecordCircle,
  Setting4,
  Box,
  Teacher,
} from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import { GAMES_CATALOG, type WebGameItem } from "../../constants/gamesCatalog";
import {
  Body,
  Grid,
  GameCard,
  IconWrap,
  GameMeta,
  GameTitle,
  GameDesc,
  TagsRow,
  Tag,
  Subtitle,
} from "./styles";

function GameIcon({ id }: Readonly<{ id: string }>) {
  const c = "#fff";
  const s = 26;
  const v = "Bold" as const;
  switch (id) {
    case "flashcards":
      return <Layer size={s} color={c} variant={v} />;
    case "flashcardsImages":
      return <Gallery size={s} color={c} variant={v} />;
    case "wordCompletion":
      return <Edit2 size={s} color={c} variant={v} />;
    case "wordMatching":
      return <Link21 size={s} color={c} variant={v} />;
    case "completeSign":
      return <FingerScan size={s} color={c} variant={v} />;
    case "wordBuilder":
      return <Box1 size={s} color={c} variant={v} />;
    case "connectDots":
      return <RecordCircle size={s} color={c} variant={v} />;
    case "signBuilder":
      return <Setting4 size={s} color={c} variant={v} />;
    case "signPuzzle":
      return <Box size={s} color={c} variant={v} />;
    case "dactylologyPuzzle":
      return <Teacher size={s} color={c} variant={v} />;
    default:
      return <Layer size={s} color={c} variant={v} />;
  }
}

const GamesPage: React.FC = () => {
  const navigate = useNavigate();
  const list = useMemo(() => GAMES_CATALOG, []);

  const openGame = (g: WebGameItem) => {
    navigate(`/games/${g.id}`);
  };

  return (
    <MobileLayout
      headerTitle="Jogos educativos"
      headerType="private"
      headerDescription="Aprenda brincando e divirta-se enquanto estuda Libras!"
    >
      <Body>
        <Subtitle>
          Escolha um jogo para praticar com palavras reais do sinalário. Cada
          acerto gera XP na liga semanal.
        </Subtitle>
        <Grid>
          {list.map((g) => (
            <GameCard key={g.id} type="button" onClick={() => openGame(g)}>
              <IconWrap $bg={g.color}>
                <GameIcon id={g.id} />
              </IconWrap>
              <GameMeta>
                <GameTitle>{g.title}</GameTitle>
                <GameDesc>{g.description}</GameDesc>
                <TagsRow>
                  <Tag>{g.difficulty}</Tag>
                  <Tag>{g.estimatedTime}</Tag>
                  <Tag>Jogar</Tag>
                </TagsRow>
              </GameMeta>
            </GameCard>
          ))}
        </Grid>
      </Body>
    </MobileLayout>
  );
};

export default GamesPage;
